import { Button, Chip, Link, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { getInvoiceFileLink } from 'api/invoices';
import { getFormattedChfCurrency } from 'utils';
import { PrintOutlined, RemoveRedEyeOutlined } from '@mui/icons-material';
import { Invoice, InvoicePaymentStatus } from 'types';
import { BUTTON_HEIGHT_CONSTANT } from 'shared';

const PaymentStatusChip = ({ status }: { status: InvoicePaymentStatus }) => {
  const statuses = {
    [InvoicePaymentStatus.OPEN]: {
      label: 'Offen',
      backgroundColor: 'primary.light',
      textColor: 'primary.main',
    },
    [InvoicePaymentStatus.PAID]: {
      label: 'Bezahlt',
      backgroundColor: 'success.light',
      textColor: 'success.dark',
    },
  };
  const statusConfig = statuses[status];
  return (
    <Chip
      sx={{
        fontSize: '10px',
        backgroundColor: statusConfig.backgroundColor,
        '& .MuiChip-label': { px: '10px', color: statusConfig.textColor, fontWeight: 'bold' },
      }}
      size="small"
      label={statusConfig.label}
    />
  );
};

// If you will need to specify additional cell props create generic type which extends from this one and use it
type InvoicesTableCell = {
  invoice: Invoice;
};

export const DateCell = ({ invoice }: InvoicesTableCell) => {
  return <Typography>{DateTime.fromISO(invoice.invoiceDate).toFormat('dd.MM.yyyy')}</Typography>;
};

export const InvoiceLinkCell = ({ invoice }: InvoicesTableCell) => {
  return (
    <Link href={getInvoiceFileLink(invoice.id)} target="_blank">
      {invoice.businessInvoiceId}
    </Link>
  );
};

export const InvoiceCampaignCell = ({ invoice }: InvoicesTableCell) => {
  return <Typography>{invoice.campaignName}</Typography>;
};

export const InvoiceAmountCell = ({ invoice }: InvoicesTableCell) => {
  return (
    <Typography data-testid="invoice-amount-cell" fontWeight="bold">
      {getFormattedChfCurrency(invoice.amount, true)}
    </Typography>
  );
};

export const InvoiceActionCell = ({ invoice }: InvoicesTableCell) => {
  return (
    <Stack spacing={2} alignItems={{ xs: 'flex-start', md: 'flex-end' }}>
      <Button
        LinkComponent={Link}
        href={getInvoiceFileLink(invoice.id)}
        sx={(theme) => ({ maxHeight: theme.spacing(BUTTON_HEIGHT_CONSTANT), fontSize: '12px' })}
        startIcon={<RemoveRedEyeOutlined />}
      >
        Rechnung ansehen
      </Button>
      <Button
        LinkComponent={Link}
        href={getInvoiceFileLink(invoice.id)}
        sx={(theme) => ({ maxHeight: theme.spacing(BUTTON_HEIGHT_CONSTANT), fontSize: '12px' })}
        startIcon={<PrintOutlined />}
      >
        Rechnung drucken
      </Button>
    </Stack>
  );
};

export const InvoicesStatusCell = ({ invoice }: InvoicesTableCell) => {
  return <PaymentStatusChip status={invoice.paymentStatus} />;
};
